import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { BehaviorSubject, catchError, map, mergeMap, Observable, of, skip, skipWhile, startWith, switchMap, take, tap } from 'rxjs';
import { NotificationService } from '../../core/core.module';
import { LgvPropertyService } from '../../core/services/lgv-property.service';

@Component({
    selector: 'lus-address-auto-complete',
    templateUrl: './address-auto-complete.component.html',
    styleUrls: ['./address-auto-complete.component.scss'],
    //changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressAutoCompleteComponent implements OnInit, OnChanges {
    @Input() addressControl: FormControl;
    @Input() unitNumberControl: FormControl;
    @Input() cityControl: FormControl;
    @Input() stateControl: FormControl;
    @Input() zipControl: FormControl;
    @Input() showAllFields: boolean;
    @Input() streetOnly: boolean = false;
    @Input() addressInitialValue: string;
    @Input() addressIsRequired: boolean;
    @Output() onAddressChanged: EventEmitter<any> = new EventEmitter();

    addressList: Observable<any[]>;
    isAddressLoading$ = new BehaviorSubject(false);
    @ViewChild('placesRef') placesRef: GooglePlaceDirective;
    @ViewChild('placesRef') placesRefHtml: HTMLElement;
    options = {
        fields: ['address_components'],
        types: ['address'],
        country: ['US']
    };

    addressFieldModel: string = '';

    constructor(private lgvPropertyService: LgvPropertyService,
        private notifService: NotificationService) { }

    ngOnChanges(simpleChanges: SimpleChanges) {
        console.log(simpleChanges);
    }

    onModelChange(event: any) {
        this.addressControl.setValue(this.addressFieldModel);
        this.onAddressChanged.emit({
            address: this.addressFieldModel,
            unitNumber: this.unitNumberControl.value,
            city: this.cityControl.value,
            state: this.stateControl.value,
            zip: this.zipControl.value
        });
    }

    ngOnInit() {
        this.addressFieldModel = this.addressInitialValue ? this.addressInitialValue : this.addressControl?.value;

        this.addressList = this.addressControl?.valueChanges.pipe(
            //tap(t => {console.log('Tap from value changes') }),
            take(0), // don't trigger for now with google auto complete
            startWith(''),
            skip(4),
            switchMap(address => {
                this.isAddressLoading$.next(true);
                if (typeof (address) !== 'string') {
                    return of({
                        result: {
                            suggestions: []
                        }
                    })
                    // do not perform a search if query length is invalid from batchdata standards
                } else if (address.length < 4 || address.length > 25) {
                    return of([]);
                } else {
                    const body = {
                        searchCriteria: {
                            query: address
                        },
                        options: {
                            skip: 0,
                            take: 5
                        }
                    };
                    return this.lgvPropertyService.searchBatchDataAddress(body).pipe(catchError(() => {
                        this.notifService.error('There was an error with the address search. Please try again.')
                        return of([]);
                    }));
                }
            }),
            map(response => {
                this.isAddressLoading$.next(false);
                return response?.result?.suggestions;
            })
        );
    }

    displayFn(addressObj: any): string {
        return addressObj?.name;
    }


    public handleAddressChange(address: Address) {
        //console.log('handleAddressChange():');

        // Do some stuff
        console.log(address)
        const streetAddress = address.address_components.find(a => a.types.includes("street_number")).short_name + " " + address.address_components.find(a => a.types.includes("route")).short_name;
        const state = address.address_components.find(a => a.types.includes("administrative_area_level_1")).short_name;
        const zip = address.address_components.find(a => a.types.includes("postal_code")).short_name;
        const city = !address.address_components.find(a => a.types.includes("locality"))?.short_name ?
            address.address_components.find(a => a.types.includes("neighborhood"))?.short_name :
            address.address_components.find(a => a.types.includes("locality"))?.short_name;

        let addressDisplay = this.showAllFields ? streetAddress : `${streetAddress} ${city} ${state}`;
        //(document.getElementById('autocompletePlaces') as any).value = addressDisplay;
        this.addressFieldModel = addressDisplay;

        if (this.cityControl) {
            this.cityControl.setValue(city);
        }
        if (this.stateControl) {
            this.stateControl.setValue(state);
        }
        this.zipControl.setValue(zip);

        const addressValue = this.streetOnly ? streetAddress : {
            address: streetAddress,
            city,
            state,
            zip
        };
        this.addressControl.setValue(addressValue);

        this.onAddressChanged.emit({
            address: streetAddress,
            unitNumber: this.unitNumberControl?.value,
            city: this.cityControl?.value,
            state: this.stateControl?.value,
            zip: this.zipControl?.value
        });

    }
}
